export const SP_MAX_WIDTH = '500px'
